//--import---
import 'ol/ol.css';
import ol from 'ol';
import Map from 'ol/Map';
import Stamen from 'ol/source/Stamen';
import LayerTile from 'ol/layer/Tile';
import LayerImage from 'ol/layer/Image';
import TileWMS from 'ol/source/TileWMS';
import ImageWMS from 'ol/source/ImageWMS';
import View from 'ol/View';
import {getCenter} from 'ol/extent';
import WMSCapabilities from 'ol/format/WMSCapabilities';
import Projection from 'ol/proj/Projection';
import {MousePosition} from 'ol/control';
import {createStringXY} from 'ol/coordinate';
import {ScaleLine, defaults as defaultControls} from 'ol/control';
import {
  addCoordinateTransforms,
  addProjection,
  transform,
  METERS_PER_UNIT,
  transformExtent,
  fromLonLat,
} from 'ol/proj';
import Vector from 'ol/layer';
import {Circle} from 'ol/style';

import LayerSwitcher from 'ol-layerswitcher';
import { BaseLayerOptions, GroupLayerOptions, getGroupsAndLayers} from 'ol-layerswitcher';
import LayerGroup from 'ol/layer/Group';
import SourceImageArcGISRest from 'ol/source/ImageArcGISRest';
import SourceOSM from 'ol/source/OSM';
import SourceStamen from 'ol/source/Stamen';
//---------------------------------

//--define map general parameters
const extentWGS84 = [130.000, 30.000, 145.000, 50.000]
const extent = transformExtent(extentWGS84, 'EPSG:4326', 'EPSG:3857');
const japanLatLon = [137.000, 40.000];
const japanMercator = fromLonLat(japanLatLon);
const format = 'image/png';
// const domainAWS = 'http://ec2-35-77-230-164.ap-northeast-1.compute.amazonaws.com/cgi-bin/';
// const domainAWS = 'http://ec2-35-72-245-2.ap-northeast-1.compute.amazonaws.com/cgi-bin/';
const domainAWS = 'http://ec2-3-112-156-168.ap-northeast-1.compute.amazonaws.com/cgi-bin/';
const domainInternal = 'http://mapserver.internal.getc.co.jp:8080/cgi-bin/';
// var bounds = [128.6875, 30.449999, 132.0875, 34.44];

const menu_en = {
  "tempTitle": "Temperature",
  "rainTitle": "Rainfall",
  "meteoTitle": "Meteorological data",
  "GFTitle": "GETFLOWS results",
  "basemapTitle": "Base maps"
};
//------------------------------------

function callGetCapa(callback){
  // function that get the layer list from the wms service
  // asynchronous call with callback for using the response
  const parserCapabilities = new WMSCapabilities();
  fetch(domainAWS + 'mapserv?map=/etc/mapserver/realtime_rainfall.map&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities')
    .then(function (response) {
      return response.text();
    })
    .then(function (text) {
      const result = parserCapabilities.read(text);
      const layers = result.Capability.Layer.Layer;
      let listLayers = [];
      layers.forEach(element => listLayers.push(element.Name));
      listLayers.pop();// last element is 'metadata' and should be removed
      listLayers.reverse();
      callback(listLayers);
    });
};

const mousePositionControl = new MousePosition({
  className: 'custom-mouse-position',
  target: document.getElementById('location'),
  coordinateFormat: createStringXY(5),
  undefinedHTML: '&nbsp;'
});

//--basemap
const tileStamen = new LayerTile({
  title: 'Stamen terrain',
  type: 'base',
  visible: true,
  source: new Stamen({layer: 'terrain'})
})

const tileOSM = new LayerTile({
  title: 'OSM',
  type: 'base',
  visible: true,
  source: new SourceOSM()
})

function createNowLayerName() {
  const this_date = new Date();
  this_date.setHours(this_date.getHours() - 1);
  return 'time_' + this_date.getFullYear().toString()
                 + this_date.getMonth().toString().padStart(2, '0')
                 + this_date.getDate().toString().padStart(2, '0')
                 + this_date.getHours().toString().padStart(2, '0') + '0000';
}

function createImageWMS(dataType) {
  return new ImageWMS({
    // url: 'http://ec2-35-77-230-164.ap-northeast-1.compute.amazonaws.com/cgi-bin/mapserv?map=/etc/mapserver/realtime_temperature.map&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&BBOX=24.18840000000000146,123.8559999999999945,45.5625,145.1189999999999998&CRS=EPSG:4326&WIDTH=549&HEIGHT=552&LAYERS=time_20220222060000&STYLES=&FORMAT=image/png&DPI=144&MAP_RESOLUTION=144&FORMAT_OPTIONS=dpi:144&TRANSPARENT=TRUE',
    url: domainAWS + 'mapserv?map=/etc/mapserver/realtime_' + dataType + '.map&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap',
    params: {'FORMAT': 'image/png', 'VERSION': '1.3.0', "LAYERS": createNowLayerName(),
      serverType: 'mapserver',
      ratio: 1
        // "exceptions": 'application/vnd.ogc.se_inimage',
        // crossOrigin: 'anonymous' 
    }
  });
}

function createLayerImage(dataType) {
  return new LayerImage({
    title: dataType,
    opacity: 0.5,
    visible: true,
    source: createImageWMS(dataType.toLowerCase())
  });
}

const imageTemp = createLayerImage(menu_en.tempTitle);
const imageRain = createLayerImage(menu_en.rainTitle);

//var sourceInternal = new ImageWMS({
  // url: domainInternal + 'mapserv?map=/etc/mapserver/realtime_test_20211216_rainfall.map&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&BBOX=24.18840000000000146,123.8559999999999945,45.5625,145.1189999999999998&CRS=EPSG:4326&WIDTH=549&HEIGHT=552&LAYERS=time_20211216140000&STYLES=&FORMAT=image/png&DPI=144&MAP_RESOLUTION=144&FORMAT_OPTIONS=dpi:144&TRANSPARENT=TRUE',
//  url: domainInternal + 'mapserv?map=/etc/mapserver/realtime_test_20211216_rainfall.map&SERVICE=WMS&REQUEST=GetMap',
//  params: {'FORMAT': 'image/png', 'VERSION': '1.3.0', "LAYERS": 'time_20211216000000',},
//  serverType: 'mapserver',
//  ratio: 1,
//});

const layerArray = [
  new LayerGroup({
      title: menu_en.basemapTitle,
      layers: [
          tileOSM,
          tileStamen
      ]
  }),
  new LayerGroup({
      title: menu_en.meteoTitle,
      layers: [
          imageTemp,
          imageRain
      ]
  }),
  new LayerGroup({
      title: menu_en.GFTitle,
      layers: [
      ]
  })
];

// var projection = new _olDefault.default.proj.Projection({
//   code: 'EPSG:4326',
//   units: 'degrees',
//   axisOrientation: 'neu',
//   global: true
// });

const projection = new Projection({
  code: 'EPSG:4326',
  // units: 'degrees',
  units: 'm',
  axisOrientation: 'neu',
  // global: true
});


const view = new View({
  center: japanMercator, //getCenter(extent)
  zoom: 5,
  // projection: projection
});

const map = new Map({
  controls: defaultControls({attribution: false}).extend([mousePositionControl]),
  layers: layerArray,
  target: 'map',
  view: view,
});

const layerSwitcher = new LayerSwitcher({
  activationMode: 'click',
  groupSelectStyle: 'none',
  startActive: true,
}
  );

function configureMap() {
  map.addControl(layerSwitcher);
  map.getView().on('change:resolution', function(evt) {
    const resolution = evt.target.get('resolution');
    const units = map.getView().getProjection().getUnits();
    const dpi = 25.4 / 0.28;
    const mpu = METERS_PER_UNIT[units];
    let scale = resolution * mpu * 39.37 * dpi;
    if (scale >= 9500 && scale <= 950000) {
      scale = Math.round(scale / 1000) + "K";
    } else if (scale >= 950000) {
      scale = Math.round(scale / 1000000) + "M";
    } else {
      scale = Math.round(scale);
    }
    document.getElementById('scale').innerHTML = "Scale = 1 : " + scale;
  });
}



// var az = getGroupsAndLayers(map);
// console.log("az: " + JSON.stringify(az, null, 4));
// alert(JSON.stringify(az, null, 4));

// map.getView().fit(bounds, map.getSize());

// map.getView().fit(bounds, map.getSize());

function convertFromStringToDate(strDate) {
  // convert the date of the format 2022-01-30T09:00:00 (obtained via mapserver metadata)
  const date = strDate.substr(0,10).split("-");
  const time = strDate.substr(11,8).split(":");
  let remain = strDate.substr(19,)
  let ms = "000"
  if (remain.includes("."))
  {
    ms = remain.substr(1,3);
    remain = remain.substr(4,)
  }
  //let timezone = remain.split(/[Z\+\-]/)
  // console.log("here", date)
  // console.log("here", time)
  // console.log("here", remain)
  // console.log("here", ms)
  // console.log("here", timezone)
  return(new Date(date[0], (date[1] - 1), date[2], time[0], time[1], time[2]))
}

// let testtime = convertFromStringToDate("2022-01-30T09:00:00Z")

// const d = new Date();
// let text = d.toString(); 
// console.log("testtime: "+ testtime)
// console.log("date-now: ",  d)
// console.log("date-now-string: ",  d.toString())

// let startDate = threeHoursAgo();
// let startDate = new Date(Date.parse('2006-01-01T16:30:00.000+0900'));

// let startDate = new Date(Date.parse('2006-01-01T16:30:00.000Z'));
// let endDate = new Date(Date.parse('2006-01-01T19:30:00.000Z'));`


// aaa = read_time()
// console.log('aaa: '+ aaa)
// console.log("aaa2: "+ aaa[2])
// console.log("aaa3: "+ aaa[3])

// layer_list = aaa
// console.log("layer_list: "+ layer_list)

//let startDate = new Date(Date.parse('2021-12-16T03:30:00.000Z'));
//let endDate = new Date(Date.parse('2021-12-20T04:30:00.000Z'));

const frameRate = 1.0; // frames per second
let animationId = null;

function updateInfo(next_layer) {
  const el = document.getElementById('for-time');
  el.innerHTML = next_layer;
}

// function setTime() {
//   startDate.setMinutes(startDate.getMinutes() + 15);
//   if (startDate > Date.now()) {
//     startDate = threeHoursAgo();
//   }
//   layers[1].getSource().updateParams({'TIME': startDate.toISOString()});
//   updateInfo();
// }

// function setTime() {
//   startDate.setMinutes(startDate.getMinutes() + 60);
//   if (startDate > endDate) {
//     // startDate = new Date(Date.parse('2006-01-01T16:30:00.000+0900'));
//     // startDate = new Date(Date.parse('2021-12-16T03:30:00.000Z'));
//     // startDate = new Date(Date.parse('2021-01-16T03:30:00.000Z'));
//     startDate = new Date(Date.parse('2021-01-18T00:00:00.000Z'));
//   }
//   tiled2.getSource().updateParams({'TIME': startDate.toISOString()});
//   updateInfo();
// }

let counter = 0;

function setlayerTime() {
  callGetCapa(function(listLayers){
    // listLayers = listLayers.reverse();
    const next_layer = listLayers[counter]
    imageTemp.getSource().updateParams({"LAYERS": next_layer});
    imageRain.getSource().updateParams({"LAYERS": next_layer});
    const current_time = listLayers[counter].slice(5,-1);
    updateInfo(current_time.slice(0,4) + "/" + current_time.slice(4,6) + "/" + current_time.slice(6,8) + " " + current_time.slice(8,10) + ":" + current_time.slice(10,12));
    counter++;
    if (counter > listLayers.length) {
      counter = 0;
    }    
  });
}

const stop = function () {
  if (animationId !== null) {
    window.clearInterval(animationId);
    animationId = null;
  }
};

const play = function () {
  stop();
  animationId = window.setInterval(setlayerTime, 1000 / frameRate);
};

// play();

// const startButtonTemp = document.getElementById('play');
// startButtonTemp.addEventListener('click', play, false);

// const stopButtonTemp = document.getElementById('pause');
// stopButtonTemp.addEventListener('click', stop, false);

// updateInfo("0000-00-00 00:00");

const playButton = d3.select("#play-button");

function resetTimer() {
  // moving = false;
    // clearInterval(timer);

    if (animationId !== null) {
      window.clearInterval(animationId);
      animationId = null;
    }

   playButton.text("Play");
}

function doPlayButton() {
  playButton.on("click", function () {
    const button = d3.select(this);
    if (button.text() == "Pause") {
     resetTimer();
    } else {
      // moving = true;
      // timer = setInterval(update, 1000);
      button.text("Pause");
      animationId = window.setInterval(setlayerTime, 1000 / frameRate);
    }
  });
}

// --- test of the xml parsing method
// text = `
// <TimePeriod>
//   <beginPosition>2022-01-30T05:00:00</beginPosition>
//   <endPosition>2022-02-02T04:00:00</endPosition>
// </TimePeriod>`;
// const parser = new DOMParser();
// xmlDoc = parser.parseFromString(text, "text/xml");
//----------------------------------------

// console.info(tiled2.getSource())

// console.info(layers[1].getSource())

// const parser = new WMSCapabilities();
// fetch('http://geonode.internal.getc.co.jp:80/geoserver/time_test/wms?service=wms&layers=time_test%3Arainfall_tokyo_multi_time_matview&request=GetCapabilities')
//   .then(function (response) {
//     return response.text();
//   })
//   .then(function (text) {
//     const result = parser.read(text);
//     const resultObj = JSON.parse(text);
//     console.log(resultObj)
//     console.log(result)
//     // console.log(JSON.stringify(result, null, 2))
//     // document.getElementById('log').innerText = JSON.stringify(result, null, 2);
//   });

// var tiled2 = new LayerTile({
//   opacity: 0.5,
//   visible: true,
//   source: new TileWMS({
//     url: 'http://geonode.internal.getc.co.jp:80/geoserver/time_test/wms',
//     params: {'FORMAT': format, 
//              'VERSION': '1.1.1',
//              tiled: true,
//           "STYLES": 'rainfall_nhk_no_border',
//           "LAYERS": 'time_test:rainfall_latest_kyushu',
//           "exceptions": 'application/vnd.ogc.se_inimage',
//           tilesOrigin: 128.6875 + "," + 30.449999
//     }
//   })
// });

// <BoundingBox SRS="EPSG:4326" minx="-1.0" miny="-1.0" maxx="0.0" maxy="0.0"/>
// <BoundingBox SRS="EPSG:3785" minx="-111319.49079327357" miny="-110579.96497035255" maxx="0.0" maxy="-7.081154551613622E-10"/>
// <BoundingBox SRS="EPSG:3857" minx="-111319.49079327357" miny="-111325.14286638597" maxx="0.0" maxy="-7.081154551613622E-10"/>
// <BoundingBox SRS="EPSG:900913" minx="-111319.49079327357" miny="-111325.14286638597" maxx="0.0" maxy="-7.081154551613622E-10"/>
// <BoundingBox SRS="EPSG:32647" minx="-2.450519666009094E7" miny="-1100225.1120296645" maxx="-2.372565893197646E7" maxy="0.0"/>
// <BoundingBox SRS="EPSG:32736" minx="-3528804.3053306043" miny="9866491.669751624" maxx="-3394492.4987732884" maxy="1.0E7"/>

// const projection = new Projection({
//   code: 'EPSG:4326',
//   // The extent is used to determine zoom level 0. Recommended values for a
//   // projection's validity extent can be found at https://epsg.io/.
//   extent: [485869.5728, 76443.1884, 837076.5648, 299941.7864],
//   units: 'm',
// });

// addProjection(projection);

// var map = new Map({
//   controls: defaultControls({
//     attribution: false
//   }).extend([mousePositionControl]),
//   target: 'map',
//   // layers: [base, untiled, tiled],
//   layers: [base],
//   // layers: [untiled, tiled],
//   view: new View({
//     // projection: projection,
//     // extent: extent,
//     zoom: 20,
//   }),
// });

//--- parse metadata obtained with GetMetadata
// const parser = new DOMParser();
// fetch('http://mapserver.internal.getc.co.jp:8080/cgi-bin/mapserv?map=/etc/mapserver/realtime_rainfall.map&request=GetMetadata&layer=metadata')
//   .then(function (response) {
//     return response.text();
//   })
//   .then(function (text) {
//     xmlDoc = parser.parseFromString(text, "text/xml");
    
//     timePeriod = xmlDoc.getElementsByTagName("gmd:MD_Metadata")[0].getElementsByTagName("gmd:identificationInfo")[0].getElementsByTagName("gmd:MD_DataIdentification")[0].getElementsByTagName("gmd:extent")[0].getElementsByTagName("gmd:EX_Extent")[0].getElementsByTagName("gmd:temporalElement")[0].getElementsByTagName("gmd:EX_TemporalExtent")[0].getElementsByTagName("gmd:extent")[0].getElementsByTagName("gml:TimePeriod")[0]
//     console.log(timePeriod)
//     beginPosition = timePeriod.getElementsByTagName('gml:beginPosition')[0].innerHTML;
//     endPosition = timePeriod.getElementsByTagName('gml:endPosition')[0].innerHTML;

//     console.log(beginPosition)
//     console.log(endPosition)
    
//     // let wms_startDate = Date(Date.parse(beginPosition));
//     // let wms_endDate = Date(Date.parse(endPosition));
//     let wms_startDate = Date.parse(beginPosition);
//     let wms_endDate = Date.parse(endPosition);
    
//     console.log("wms_startDate: " + typeof   wms_startDate);
//     console.log("wms_endDate: " + typeof wms_endDate);
//   });
//--------------------------------------------------

// const parser = new WMSCapabilities();
// fetch('http://mapserver.internal.getc.co.jp:8080/cgi-bin/mapserv?map=/etc/mapserver/realtime_test_20211216_rainfall.map&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities')
//   .then(function (response) {
//     return response.text();
//   })
//   .then(function (text) {
//     const result = parser.read(text);
//     console.log("results: " + result)

//     // console.log("aaa: " + text)
//     // const resultObj = JSON.parse(text);
//     // console.log(resultObj)
//     // console.log(JSON.stringify(result, null, 2))
//     const result2 = JSON.stringify(text, null, 2)
//     // const time_from_wms = result2.Layer.Layer[2].Dimension[0].values
//     // const time_from_wms = result.Capability.Layer.Layer[1].Dimension[0].values.split("/");
    
//     console.log("WMS date:", time_from_wms);

//     // let wms_startDate = Date(Date.parse(time_from_wms[0]));
//     // let wms_endDate = Date(Date.parse(time_from_wms[1]));

// // console.info("now ms:", Date.now())
// // console.info("now ms rounded:", Math.round(Date.now() / 3600000) * 3600000)
// // console.info("now time rounded:", Date(Math.round(Date.now() / 3600000) * 3600000))
// // console.info("now time:", Date(Date.now()))
// // console.info("startDate:", startDate)
// // console.info("startDate.toISOString():", startDate.toISOString())

// // console.log("WMS startDate:", wms_startDate);
// // console.log("WMS endDate:", wms_endDate);
// // console.log("Now:", Date.now());

// // console.log("WMS startDate:", Date('1639454400000'));
// // console.log("WMS endDate:", Date(Date.parse(time_from_wms[1])));
// // console.log("Now:", Date(Date.now()));

// // document.getElementById('log').innerText = JSON.stringify(result, null, 2);
// });

// var tiledMapserver = new LayerTile({
//   opacity: 0.5,
//   visible: true,
//   source: new TileWMS({
//     url: 'http://mapserver.internal.getc.co.jp:8080/cgi-bin/mapserv?map=/etc/mapserver/realtime_test_20211216_rainfall.map&layer=20211216120000&mode=map',
//     params: {'FORMAT': format, 
//              'VERSION': '1.1.1',
//              tiled: true,
//           "LAYERS": '20220128130000',
//           // "exceptions": 'application/vnd.ogc.se_inimage',
//           tilesOrigin: 128.6875 + "," + 30.449999
//     }    
//   })
// });

// var tiledMapserver = new LayerTile({
//   opacity: 0.5,
//   visible: true,
//   source: new TileWMS({
//     url: 'http://mapserver.internal.getc.co.jp:8080/cgi-bin/mapserv?map=/etc/mapserver/realtime_test_20211216_rainfall.map&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&BBOX=24.18840000000000146,123.8559999999999945,45.5625,145.1189999999999998&CRS=EPSG:4326&WIDTH=549&HEIGHT=552&LAYERS=time_20211216140000&STYLES=&FORMAT=image/png&DPI=144&MAP_RESOLUTION=144&FORMAT_OPTIONS=dpi:144&TRANSPARENT=TRUE',
//     params: {'FORMAT': format, 
//              'VERSION': '1.3.0',
//              tiled: true,
//           "LAYERS": 'time_20211216000000',
//           // "exceptions": 'application/vnd.ogc.se_inimage',
//           // tilesOrigin: 128.6875 + "," + 30.449999
//     }    
//   })
// });

// var imageMapserver = new Image({
//   opacity:0.5,
//   ratio: 1,
//   visible: true,
//   source: new ImageWMS({
//     // serverType: 'mapserver',
//     url: 'http://mapserver.internal.getc.co.jp:8080/cgi-bin/mapserv?map=/etc/mapserver/realtime_test_20211216_rainfall.map&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&BBOX=24.18840000000000146,123.8559999999999945,45.5625,145.1189999999999998&CRS=EPSG:4326&WIDTH=549&HEIGHT=552&LAYERS=time_20211216140000&STYLES=&FORMAT=image/png&DPI=144&MAP_RESOLUTION=144&FORMAT_OPTIONS=dpi:144&TRANSPARENT=TRUE',
//     params: {'FORMAT': format,
//              'VERSION': '1.3.0',  
//           "LAYERS": 'time_20211216000000',
//           // "exceptions": 'application/vnd.ogc.se_inimage',
//     }
//   })
// });

// var tiledMapserver = new LayerTile({
//   opacity: 0.5,
//   visible: true,
//   source: new TileWMS({
//     url: 'http://mapserver.internal.getc.co.jp:8080/cgi-bin/mapserv',
//     params: {'FORMAT': format, 
//     'VERSION': '1.1.1',
//     tiled: true,
//  "STYLES": 'rainfall_nhk_no_border',
//  "LAYERS": 'time_test:rainfall_latest_kyushu',
//  "exceptions": 'application/vnd.ogc.se_inimage',
//  tilesOrigin: 128.6875 + "," + 30.449999
//     }    
//   })
// });

// http://mapserver.internal.getc.co.jp:8080/cgi-bin/mapserv?map=/etc/mapserver/realtime_test_20211216_rainfall.map&layer=20211216120000&VERSION=1.1.1&SERVICE=WMS&REQUEST=GetMap&FORMAT=application/openlayers&WIDTH=512&HEIGHT=512&SRS=EPSG:26915&BBOX=429956.19803725,5231780.0814818,444078.32296225,5245902.2064068
// http://mapserver.internal.getc.co.jp:8080/cgi-bin/mapserv?mode=browse&template=openlayers&layer=lakespy2&layer=dlgstln2&map=/etc/mapserver/realtime_rainfall.map&layer=20220128130000
// http://mapserver.internal.getc.co.jp:8080/cgi-bin/mapserv?map=/etc/mapserver/realtime_rainfall.map&layer=20220128130000&mode=map

    // var lon = 140.0;
    // var lat = 35.0;
    // var zoom = 5;
    // var map = new OpenLayers.Map('map');
    // var localWMS = new OpenLayers.Layer.WMS(
    //   "Local WMS layers",
    //   "http://app.example.com/cgi-bin/mapserver?map=/opt/maps/map07.map",
    //   {layers: ['countries','lakes','rivers','cities','roads','rails'], transparent: false},
    //   {isBaseLayer: true}
    // );
    // map.addLayer(localWMS);
    // map.setCenter(new OpenLayers.LonLat(lon, lat), zoom);
    // map.addControl(new OpenLayers.Control.LayerSwitcher());

function run() {
  configureMap();
  setlayerTime();
  doPlayButton();
}

run();
